<template>
    <div class="Nuevo">
        <Menu :sesion="sesion" :url="url" v-if="sesion"/>
        <Submenu :url="url"/>

        <div class="container pt-3">
            <router-link to="/Proyectos" class="notLink">
                <font-icon icon="arrow-circle-left"/> Regresar
            </router-link>

            <div class="card mt-2">
                <div  class="orange-div card-header">
                    <h3 class="card-title">Cuéntanos que necesitas hacer</h3>
                    <p class="pt-2">Póngase en contacto con profesionales autónomos expertos en SAP. Vea sus perfiles, calificaciones,
                        hable con ellos y reciba ofertas a su proyecto.</p>
                </div>
                <form @submit="publicar">
                    <div class="card-body">
                        <div class="form-group">
                            <h6><b>Nombre del Proyecto</b></h6>
                            <input type="text" class="form-control" v-model="nombreProyecto" placeholder="" required>
                        </div>

                        <div class="row">
                            <div class="col-4 mb-3">
                                <h6><b>Producto</b></h6>
                                <select class="form-control" required v-model="producto">
                                    <option value="">--Selecciona un producto--</option>
                                    <option :value="f.nombre_producto" v-for="f in productos" :key="f.id">{{f.nombre_producto}} </option>
                                </select>
                            </div>
                            <div class="col-4 mb-3">
                                <h6><b>Version</b></h6>
                                <input type="text" class="form-control" required v-model="version">
                            </div>
                            <div class="col-4 mb-3">
                                <h6><b>Pago por avance</b></h6>
                                <div class="btn-group btn-group-toggle pl-2" data-toggle="buttons">
                                <label class="btn btn-outline-secondary active">
                                    <input type="radio" name="options" id="option1" @click="toggle('1')" checked> Si
                                </label>
                                <label class="btn btn-outline-secondary">
                                    <input type="radio" name="options" id="option2" @click="toggle('0')"> No
                                </label>
                            </div>
                            </div>
                        </div>

                        <div class="row mb-3">
                            <div class="col-3">
                                <h6><b>Fecha de Inicio</b></h6>
                                <input type="date" id="dateInicioProyecto" class="form-control" required v-model="fechaInicio">
                            </div>
                            <div class="col-3">
                                <h6><b>Fecha de Entrega</b></h6>
                                <input type="date" id="dateVigencia" class="form-control" required v-model="fechaFin">
                            </div>
                            <div class="col-3">
                                <h6><b>Idiomas del Proyecto</b></h6>
                                <select class="form-control" id="customCheck1" v-model="idioma" required>
                                    <option value="">--Idioma--</option>
                                    <option v-for="f in idiomas" :key="f.id_language" :value="f.language">{{f.language}}</option>
                                </select>
                            </div>
                            <div class="col-3">
                                <h6><b>¿Requiere un segundo idioma?</b></h6>
                                <select class="form-control" id="customCheck1" v-model="idioma2">
                                    <option value="">--Idioma--</option>
                                    <option v-for="f in idiomas" :key="f.id_language" :value="f.language">{{f.language}}</option>
                                </select>
                            </div>
                        </div>

                        <div class="form-group">
                            <h6><b>Explica tu proyecto</b></h6>
                            <small>{{caracteresRestantes}} carácteres restantes (Máximo 400 carácteres) </small>
                            <textarea class="form-control" rows="5" maxlength="400" v-model="notaProyecto" required></textarea>
                        </div>

                        <div class="form-group">
                            <h6><b>¿Que conocimiento se requiere?</b> 
                                <button type="button" class="btn btn-sm btn-warning" data-toggle='modal' data-target='#criterio-busqueada'>
                                    <font-icon icon="exclamation-triangle"/>
                                </button>
                            </h6>
                            <small>Máximo 3 especialidades</small>
                            <div class="row">
                                <div class="col-sm-6">
                                    <input type="text" class="form-control" v-model="buscar" placeholder="buscar...">
                                    <ul class="list-group pointer">
                                        <li class="list-group-item" v-for="f in resultBusqueda" :key="f.id_modulo" @click="select(f)">
                                            {{f.module_cod}} - {{f.module_name}}
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-sm-6">
                                    <ul>
                                        <li v-for="x in conocimientos" :key="x.id">
                                            <span class="badge badge-success">
                                                {{x.alias}} - {{x.name}}
                                            </span>
                                            <i class="text-danger pointer" @click="remove(x)">
                                                <font-icon icon="times"/>
                                            </i>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div class="form-group">
                            <h6><b>¿Tiene algun otro requerimiento sobre la experiencia del consultor?</b></h6>
                            <input  type="text" class="form-control" v-model="notaExperiencia">
                        </div>

                        <div class="form-group pt-2">
                            <h6><b>Adjuntos</b></h6>
                            <div class="row">
                                <div class="col-sm-6">
                                    <input type="file" class="form-control" @change="addFile">
                                </div>
                            </div>
                        </div>

                        <div class="text-center pt-3" >
                            <div class="">
                                <button type='button' class='btn btn-dark' data-toggle='modal' data-target='#exampleModal'>
                                    <font-icon icon="eye"/> Vista Previa
                                </button>
                                <button type='submit' id="guardar" class='btn btn-outline-dark' v-show="botonLoadingHide2">
                                    <font-icon icon="save"/> Guardar
                                </button>
                                <button class="btn orange" type="button" v-show="botonLoadingShow2" disabled>
                                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                    Guardando...
                                </button>
                                <button type="submit" id="publicar" class='btn orange' v-show="botonLoadingHide">
                                    Publicar
                                </button>
                                <button class="btn orange" type="button" v-show="botonLoadingShow" disabled>
                                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                    Publicando...
                                </button>
                            </div>
                        </div>

                    </div>
                </form>
            </div>
        </div>

        <!--Modales-->
        <div class='modal fade' id='exampleModal' tabindex='-1' role='dialog' aria-labelledby='exampleModalLabel' aria-hidden='true' data-backdrop='static'>
        <div class="modal-dialog modal-xl">
            <div class='modal-content'>

                <div class='modal-header '>
                        <h6 class='modal-title' id='exampleModalLabel'>Vista Previa del proyecto: {{nombreProyecto}}</h6>
                        <button type='button' class='close' data-dismiss='modal' aria-label='Close'>
                            <span aria-hidden='true'>&times;</span>
                        </button>
                </div>
                <div class='modal-body'>
                    <div class="form-group row">
                        <div class="col-6">
                            <span class="badge badge-dark">Nombre Proyecto</span>
                            <p class="text-vista">{{nombreProyecto}}</p>
                        </div>
                        <div class="col-2">
                            <span class="badge badge-dark">Producto</span>
                            <p class="text-vista">{{producto}}</p>
                        </div>
                        <div class="col-2">
                            <span class="badge badge-dark">Version</span>
                            <p class="text-vista">{{version}}</p>
                        </div>
                        <div class="form-check col-2">
                            <h6 class=""><span class="badge badge-dark">Pago por avance</span></h6>
                            <p v-if="pagoAvance == '1'"><u>Si</u></p>
                            <p v-if="pagoAvance == '0'"><u>No</u></p>
                        </div>
                    </div>

                    <div class="form-group row" >
                         <div class="col-2">
                            <span class="badge badge-dark">Fecha Inicio</span>
                            <p class="text-vista">{{fechaInicio}}</p>
                        </div>
                        <div class="col-2">
                            <span class="badge badge-dark">Fecha Entrega</span>
                            <p class="text-vista">{{fechaFin}}</p>

                        </div>
                        <div class="col-2">
                            <span class="badge badge-dark">Idioma</span>
                            <p class="text-vista">{{idioma}}</p>
                        </div>
                        <div class="col-2">
                            <span class="badge badge-dark">Segundo Idioma</span>
                            <p class="text-vista">{{idioma2}}</p>
                        </div>

                        <div class="form-group col-4">
                            <h6><span class="badge badge-dark">Conocimientos</span></h6>
                            <span class="badge badge-primary m-1" style="font-size: 10.5px;" v-for="y in conocimientos" :key="y.id">
                                {{y.alias}} - {{y.name}}
                            </span>
                        </div>

                        <div class="col-12">
                            <h6><span class="badge badge-dark">Resumen</span></h6>
                            <p class="text-vista">{{notaProyecto}}</p>

                        </div>

                        <div class="form-group col-12">
                            <h6><span class="badge badge-dark">Experiencia Adicional</span></h6>
                            <p class="text-vista">{{notaExperiencia}}</p>
                        </div>

                        <div class="form-group col-12">
                            <h6><span class="badge badge-dark">Adjunto</span></h6>
                            <a href="#">{{fileName}}</a>
                        </div>

                    </div>
                </div>

                <div class='modal-footer'>
                    <button type='button' class='btn btn-light' data-dismiss='modal'>Cerrar</button>
                </div>
            </div>
        </div>
        </div>

        <div class='modal fade' id='criterio-busqueada' tabindex='-1' role='dialog' aria-labelledby='exampleModalLabel' aria-hidden='true' data-backdrop='static'>
            <div class="modal-dialog modal-xs">
                <div class='modal-content'>

                    <div class='modal-header '>
                            <h6 class='modal-title' id='exampleModalLabel'>
                              <font-icon icon="exclamation-triangle"/>  Criterios para búsqueda
                            </h6>
                            <button type='button' class='close' data-dismiss='modal' aria-label='Close'>
                                <span aria-hidden='true'>&times;</span>
                            </button>
                    </div>
                    <div class='modal-body'>
                        <p>Busca por el nombre de la especialización, no por su nomenclatura.</p>
                        <b>Ejemplo</b>
                        <p class="text-center">Si requieres un consultor <b>"ABAP"</b> <br> 
                            Teclea cualquiera de las palabras de la especialización: <br>
                            <b>Advance Business Application Programming</b>  
                        </p>
                    </div>

                    <div class='modal-footer'>
                        <button type='button' class='btn btn-warning' data-dismiss='modal'>Cerrar</button>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>


<script>
import { mapState } from 'vuex'
import { globalFunctions } from '@/hooks/globalFunctions'

import $ from 'jquery'

import Submenu from '@/components/Submenu'
import Menu from '@/components/Menu'

export default {
name:'Nuevo',
mixins: [ globalFunctions ],
data(){
    return{
        resultBusqueda:[],
        botonLoadingHide: true,
        botonLoadingShow: false,
        botonLoadingHide2: true,
        botonLoadingShow2: false,
        nombreProyecto:'',
        notaProyecto: '',
        buscar:'',
        conocimientos:[],
        selectedFile: null,
        fileName:'',
        caracteresRestantes:400,
        producto: '',
        version: '',
        pagoAvance: 1,
        fechaInicio: '',
        fechaFin: '',
        statusProyecto: 2,
        idioma: '',
        idioma2: '',
        notaExperiencia: '',
        sesion: '',
        nombre_archivo: '',
        productos: [],
        idiomas: []

    }
},
components:{Submenu,Menu},
computed:{
    ...mapState(['url'])
},
methods:{

     getCatalogs(){

        this.axios.post(this.url + 'consulta_prod.php').then((responce) =>{
            this.productos = responce.data;
        });

        this.axios.post(this.url + 'consulta_idiomas.php').then((responce) =>{
            this.idiomas = responce.data;
        });
    },

    toggle(opcion){

        this.pagoAvance = opcion;
    },
    getConocimiento(param){

        if(param.length <= 0) //Salir al ser menor a 2
        {
            this.resultBusqueda = [];
            return;
        }

        let data = {
            query:param,
            flag:0
        };

        this.axios.post(this.url + 'consultasBasicas.php', data).then((responce) =>{
            this.resultBusqueda = responce.data;
        });
    },
    select(f){
        let long = this.conocimientos.length;

        const data = {
            id:f.id_modulo,
            alias:f.module_cod,
            name:f.module_name,
        }

        if(long >= 3){
            this.msjError('Solo se permiten 3 valores');

            this.resultBusqueda = [];
            this.buscar = "";
            return;
        }
        else{
            this.conocimientos.push(data);
            this.resultBusqueda = [];
            this.buscar = "";
        }
    },
    remove(x){
        let index = this.conocimientos.indexOf(x);
        this.$delete(this.conocimientos,index);
    },
    addFile(event){
        this.selectedFile = event.target.files[0];
        this.fileName = this.selectedFile.name;
    },
    resetButtons(){
        this.botonLoadingShow2 = false;
        this.botonLoadingHide2 = true;

        this.botonLoadingShow = false;
        this.botonLoadingHide = true;
    },
    publicar(e){
        e.preventDefault();

        let data = {
            flag: 0,
            nombre:this.nombreProyecto,
            cuerpo: this.notaProyecto,
            conocimientos: this.conocimientos,
            id: localStorage.userID,
            fileName: this.fileName,
            producto: this.producto,
            version: this.version,
            pagoAvance: this.pagoAvance,
            fechaInicio: this.fechaInicio,
            fechaFin: this.fechaFin,
            idioma: this.idioma,
            idioma2: this.idioma2,
            notaExperiencia: this.notaExperiencia,
        }

        if(e.submitter.id== "guardar"){
            data.status = 1;
            this.botonLoadingShow2 = true;
            this.botonLoadingHide2 = false;
        } else {
            data.status = 2;
            this.botonLoadingShow = true;
            this.botonLoadingHide = false;
        }

        if(this.conocimientos.length <= 0){
            alert("Faltan conocimientos");
            return;
        }

        if(this.selectedFile != null)
        {
            //Validar que sea pdf
            let archivo = this.selectedFile.name;
            let index = archivo.length;
            index = index - 4;
            var res = archivo.substr(index, 4);

            res.toLowerCase();

            if(res != '.pdf'){
                alert("Solo se acepta archivos con formato PDF");
                this.resetButtons();
                return;
            }
        }

        this.axios.post(this.url + 'altaProyecto.php', data).then((responce) =>{
            data.flag = 3;
            
            var id_proyecto = responce.data.id_proyecto;
            if(responce.data.res == '200'){

                if(this.selectedFile != null)
                {
                    const fd = new FormData();
                    fd.append('file',this.selectedFile, this.selectedFile.name);

                    this.axios.post(this.url + 'altaArchivo.php', fd, {
                        header:{
                            'Content-Type': 'multipart/form-data'
                        }
                    }).then((responce) =>{
                        
                        if(responce.data.res == '200'){

                            let data = {
                                flag: 1,
                                id: localStorage.userID,
                                fileName: responce.data.nombre,
                                nombre_proyecto: this.nombreProyecto
                            }

                            this.axios.post(this.url + 'altaFile.php', data).then((responce) =>{
                                if(responce.data == '200'){
                                    this.botonLoadingHide = true;
                                    this.$router.push('/Proyectos');
                                }else{
                                    this.msjError(responce.data);
                                }
                            });

                        }else{
                            this.msjError(responce.data.res);
                            this.resetButtons();
                        }
                    });
                } else {
                    this.$router.push('/Proyectos');
                }
            }else{
                this.resetButtons();
                this.msjError(responce.data);
            }
        });
    }
},
watch:{
    buscar(){
        this.getConocimiento(this.buscar);
    },
    notaProyecto(){
        let num = this.notaProyecto.length;
        this.caracteresRestantes = 400 - num;
    }
},
mounted(){
    this.getCatalogs();
    this.rol =  localStorage.rol;

        //Verificar que el token sigue vivo
        const token = localStorage.token;
        const UserName = localStorage.userID;
        const tabla = localStorage.tabla;

        let resp = this.checkUser();
        this.sesion = resp;

    if(localStorage.rol == '0'){
        this.$router.push('/perfil');
    }

    /*var maxDate = this.addFiveDaysToday();
    $('#dateVigencia').attr('min', maxDate);*/

    var min = this.addDaysToday();
    $('#dateVigencia').attr('min', min);
    //$('#dateInicioProyecto').attr('min', maxDate);
}

}
</script>


<style scoped>

.orange-div
{
  background-color: #ff200b;
  color: white;
}

select option{
    color: gray;
}
.wrapper{
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        width: 100%;
        min-height: 100%;
        padding: 20px;
}

.checkbox-1x {
    transform: scale(1.5);
    -webkit-transform: scale(1.5);
}
</style>



// WEBPACK FOOTER //
// src/views/NuevoProyecto/NuevoProyecto.vue